const globalVars = require('globalVars')

const Entities = require('html-entities').XmlEntities
const entities = new Entities()

export function relativizeURL (url) {
  return url.replace(globalVars.rootPath, '')
}

export const rootPath = globalVars.rootPath

export function decode (string) {
  return entities.decode(string)
}

export function createMarkup (markup) {
  return { __html: markup }
}

export function contentWidth () {
  let width
  if (window.innerWidth >= 1366) {
    width = window.innerWidth * 0.666
  } else if (window.innerWidth >= 1024) {
    width = 780
  }
  return width
}

export function randomNumber (min, max) {
  return Math.floor(Math.random() * (1 + max - min) + min)
}



// WEBPACK FOOTER //
// ./src/lib/Utils.js